export default __webpack_public_path__ + "static/media/tierlitaenzli-chatzeschwaenzli.4cfa165a.png";